import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Sorting } from '../_model/sorting.model';
import { Filter } from '../_model/filter.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class ParentService {
    token = localStorage.getItem('token');
    options = {
        headers: new HttpHeaders({
            // tslint:disable-next-line:object-literal-key-quotes
            'Authorization': `Bearer ${this.token}`
        })
    };

    constructor(private http: HttpClient) { }

    getParents(rowsNumber: number, pageNo: number, sorting: Sorting, searchValue: string, filterValues: Filter, request_number: number) {
        let filterValuesForGradesApi = '';
        let filterValuesForClassesApi = '';
        if (filterValues.grades !== undefined) {
            filterValues.grades.map((filterValue: string) => {
                filterValuesForGradesApi = filterValuesForGradesApi.concat('&filter[grade_id][]=' + filterValue)
            })
        }
        if (filterValues.classes !== undefined) {
            filterValues.classes.map((filterValue: string) => {
                filterValuesForClassesApi = filterValuesForClassesApi.concat('&filter[class_id][]=' + filterValue)
            })
        }
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/users?
        role_type=parent
        &is_paginated=1
        &per_page=${rowsNumber}
        ${sorting.name !== null ? '&sort[name]=' + sorting.name : ''}
        ${filterValuesForGradesApi}
        ${filterValuesForClassesApi}
        ${filterValues.registration !== -1 && filterValues.registration !== undefined ? '&filter[status][]=' + filterValues.registration : ''}
        ${filterValues.activation !== -1 && filterValues.activation !== undefined ? '&filter[activate][]=' + filterValues.activation : ''}
        &filter[role][]=parent
        &page=${pageNo}
        ${searchValue === undefined || searchValue === '' ? '' : '&search=' + encodeURIComponent(searchValue)} 

        &request_number=${request_number}`);
    }

    getHelpers(
        rowsNumber: number,
        pageNo: number,
        sorting: Sorting,
        searchValue: string,
        filterValues: Filter,
        request_number: number
    ) {
        const schoolId = localStorage.getItem('schoolId');
        const baseUrl = `${environment.url}admin/schools/${schoolId}/users`;
        const queryParams = new URLSearchParams();

        // Common query parameters
        queryParams.append('role_type', 'helper');
        queryParams.append('is_paginated', '1');
        queryParams.append('per_page', rowsNumber.toString());
        queryParams.append('page', pageNo.toString());
        queryParams.append('request_number', request_number.toString());
        queryParams.append('filter[role][]', 'helper');

        // Sorting
        if (sorting.name) {
            queryParams.append('sort[name]', sorting.name);
        }

        // Grades and Classes filters
        if (filterValues.grades) {
            filterValues.grades.forEach((grade) => queryParams.append('filter[grade_id][]', grade));
        }
        if (filterValues.classes) {
            filterValues.classes.forEach((classId) => queryParams.append('filter[class_id][]', classId));
        }

        // Additional filters
        if (filterValues.registration !== undefined && filterValues.registration !== -1) {
            queryParams.append('filter[status][]', filterValues.registration.toString());
        }
        if (filterValues.activation !== undefined && filterValues.activation !== -1) {
            queryParams.append('filter[activate][]', filterValues.activation.toString());
        }

        // Search value
        if (searchValue) {
            queryParams.append('search', searchValue);
        }

        const url = `${baseUrl}?${queryParams.toString()}`;
        return this.http.get(url);
    }


    exportParentsFile(rowsNumber: number, pageNo: number, sorting: Sorting, searchValue: string, filterValues: Filter, request_number: number) {
        let filterValuesForGradesApi = '';
        let filterValuesForClassesApi = '';
        if (filterValues.grades !== undefined) {
            filterValues.grades.map((filterValue: string) => {
                filterValuesForGradesApi = filterValuesForGradesApi.concat('&filter[grade_id][]=' + filterValue)
            })
        }
        if (filterValues.classes !== undefined) {
            filterValues.classes.map((filterValue: string) => {
                filterValuesForClassesApi = filterValuesForClassesApi.concat('&filter[class_id][]=' + filterValue)
            })
        }
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/users/export?
        role_type=parent
        &is_paginated=0
        ${sorting.name !== null ? '&sort[name]=' + sorting.name : ''}
        ${filterValuesForGradesApi}
        ${filterValuesForClassesApi}
        ${filterValues.registration !== -1 && filterValues.registration !== undefined ? '&filter[status][]=' + filterValues.registration : ''}
        ${filterValues.activation !== -1 && filterValues.activation !== undefined ? '&filter[activate][]=' + filterValues.activation : ''}
        &filter[role][]=parent
        ${searchValue === undefined || searchValue === '' ? '' : '&search=' + encodeURIComponent(searchValue)} 
        &request_number=${request_number}`);
    }

    deleteParents(body) {
        let options = this.options;
        options['body'] = body;
        return this.http.delete(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/users/delete`, options)
    }

    updateParent(parentID, body) {
        return this.http.post(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/users/${parentID}`, body)
    }

    /**
     * v2: creates the guardian *and* files the student on them, so `student_id`
     * is required. Identifier collisions come back as a resolvable 409 instead
     * of a 422, and only one conflict is reported per request — the caller
     * answers it and posts again until it gets a 201.
     */
    createParentV2(body) {
        return this.http.post(environment.url + `v2/admin/schools/${localStorage.getItem('schoolId')}/parents`, body)
    }

    searchByUserId(id) {
        return this.http.get(environment.url + `admin/users/check?national_id=${id}`)
    }

    getUserById(id, type: 'parent' | 'helper') {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/users/${id}?type=${type}`)
    }

    private _parentData = new BehaviorSubject<Object>(null);
    parentData = this._parentData.asObservable();

    setParentData(parent, flag) {
        this._parentData.next({ 'parent': parent, 'flag': flag });
    }

    getParentData() {
        return this._parentData;
    }

    assignAssistantToStudent(student_id:any , body){
        return this.http.post(environment.url + `v2/admin/schools/${localStorage.getItem('schoolId')}/students/${student_id}/store-student-user` , body)
    }
    removeStudentAssignationFromAssistant(assistant_id:any , student_id:any){
        return this.http.delete(environment.url + `v2/admin/schools/${localStorage.getItem('schoolId')}/assistants/${assistant_id}/remove-student-assignation/${student_id}`)
    }
    toogleStudentActivationFromAssistant(assistant_id:any , body){
        return this.http.post(environment.url + `v2/admin/schools/${localStorage.getItem('schoolId')}/assistants/${assistant_id}/change-pick-type` , body)
    }
}